import { useEffect, useRef, useState } from "react"

const getStyles = (placement, background, borderColor) => {
    const tooltipBase = {
        position: 'absolute',
        backgroundColor: background,
        padding: '8px',
        borderRadius: '4px',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        zIndex: 9999,
        pointerEvents: 'none',
        border: `1px solid ${borderColor}`,
        boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
    }
    const configs = {
        left: {
            tooltip: { ...tooltipBase, right: 'calc(100% + 6px)', top: '50%', transform: 'translateY(-50%)' },
            arrowBorder: { left: '100%', top: '50%', transform: 'translateY(-50%)', borderTop: '6px solid transparent', borderBottom: '6px solid transparent', borderLeft: `6px solid ${borderColor}` },
            arrowFill:   { left: 'calc(100% - 1px)', top: '50%', transform: 'translateY(-50%)', borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderLeft: `5px solid ${background}` },
        },
        right: {
            tooltip: { ...tooltipBase, left: 'calc(100% + 6px)', top: '50%', transform: 'translateY(-50%)' },
            arrowBorder: { right: '100%', top: '50%', transform: 'translateY(-50%)', borderTop: '6px solid transparent', borderBottom: '6px solid transparent', borderRight: `6px solid ${borderColor}` },
            arrowFill:   { right: 'calc(100% - 1px)', top: '50%', transform: 'translateY(-50%)', borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderRight: `5px solid ${background}` },
        },
        top: {
            tooltip: { ...tooltipBase, bottom: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)' },
            arrowBorder: { top: '100%', left: '50%', transform: 'translateX(-50%)', borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: `6px solid ${borderColor}` },
            arrowFill:   { top: 'calc(100% - 1px)', left: '50%', transform: 'translateX(-50%)', borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: `5px solid ${background}` },
        },
        bottom: {
            tooltip: { ...tooltipBase, top: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)' },
            arrowBorder: { bottom: '100%', left: '50%', transform: 'translateX(-50%)', borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderBottom: `6px solid ${borderColor}` },
            arrowFill:   { bottom: 'calc(100% - 1px)', left: '50%', transform: 'translateX(-50%)', borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderBottom: `5px solid ${background}` },
        },
    }
    return configs[placement] ?? configs.left
}

export const HoverTooltip = ({
    trigger,
    children,
    placement = 'left',
    background = '#fff',
    color = '#212529',
    borderColor = '#dee2e6',
    wrapperStyle = {},
    maxHeight,
    header,
    accentColor,
    headerBackground,
}) => {
    const [show, setShow] = useState(false)
    const hideTimeoutRef = useRef(null)
    const { tooltip, arrowBorder, arrowFill } = getStyles(placement, background, borderColor)

    const clearHideTimeout = () => {
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current)
            hideTimeoutRef.current = null
        }
    }

    const handleMouseEnter = () => {
        clearHideTimeout()
        setShow(true)
    }
    const handleMouseLeave = () => {
        hideTimeoutRef.current = setTimeout(() => setShow(false), 150)
    }

    useEffect(() => clearHideTimeout, [])
    const contentStyle = maxHeight ? {
        display: 'block',
        maxHeight,
        minWidth: 180,
        maxWidth: 280,
        overflowY: 'auto',
        whiteSpace: 'normal',
        pointerEvents: 'auto',
    } : undefined

    const accentStyle = accentColor ? { borderTop: `3px solid ${accentColor}` } : undefined
    const headerStyle = header ? {
        display: 'block',
        padding: '9px 14px',
        fontWeight: 700,
        fontSize: '11px',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        backgroundColor: headerBackground ?? background,
        color: accentColor ?? color,
    } : undefined

    return (
        <span
            style={{ position: 'relative', display: 'inline-block', ...wrapperStyle }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {trigger}
            {show && (
                <span style={{ ...tooltip, color, ...accentStyle }}>
                    {header && <span style={headerStyle}>{header}</span>}
                    <span style={contentStyle}>
                        {children}
                    </span>
                    <span style={{ position: 'absolute', width: 0, height: 0, ...arrowBorder }} />
                    <span style={{ position: 'absolute', width: 0, height: 0, ...arrowFill }} />
                </span>
            )}
        </span>
    )
}
